/** Preserve clicked duplicate-tile identities while also supporting keyboard input. */
export function selectWordTiles(tiles, symbols, normalizedWord, preferredIds = new Set(), jokerChoices = new Map()) {
  const available = [...tiles].sort((first, second) => Number(preferredIds.has(second.id)) - Number(preferredIds.has(first.id)));
  const configuredSymbols = [...symbols].sort((first, second) => second.length - first.length);
  const selectedIds = new Set();
  const selectedTiles = [];
  let offset = 0;
  while (offset < normalizedWord.length) {
    const symbol = configuredSymbols.find(candidate => normalizedWord.startsWith(candidate, offset));
    const fits = candidate => !selectedIds.has(candidate.id) && (candidate.symbol === symbol
      || (candidate.symbol === 'JK' && (!jokerChoices.has(candidate.id) || jokerChoices.get(candidate.id) === symbol)));
    const tile = symbol && (available.find(candidate => preferredIds.has(candidate.id) && (candidate.symbol !== 'JK' || jokerChoices.has(candidate.id)) && fits(candidate))
      ?? available.find(candidate => candidate.symbol === symbol && fits(candidate))
      ?? available.find(candidate => candidate.symbol === 'JK' && fits(candidate)));
    if (!tile) break;
    selectedIds.add(tile.id);
    selectedTiles.push(tile.symbol === 'JK' ? { ...tile, symbol, joker: true } : tile);
    offset += symbol.length;
  }
  return { selectedIds, selectedTiles, remainder: normalizedWord.slice(offset),
    points: selectedTiles.reduce((total, tile) => total + tile.points, 0) };
}
